
class awsAppsyncServices {
}


  const instance = new awsAppsyncServices();

export default instance;
